// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"226565e5","66":"bb160439","221":"cc085d66","350":"a45a0f9f","501":"4348b904","782":"375de821"}[chunkId] + ".chunk.js";
};